var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.9024 2.50395C22.6407 1.51853 21.8696 0.742447 20.8906 0.479072C19.116 0.000488281 12.0001 0.000488281 12.0001 0.000488281C12.0001 0.000488281 4.88427 0.000488281 3.10965 0.479072C2.13061 0.742488 1.35952 1.51853 1.09781 2.50395C0.622314 4.29007 0.622314 8.01665 0.622314 8.01665C0.622314 8.01665 0.622314 11.7432 1.09781 13.5294C1.35952 14.5148 2.13061 15.2585 3.10965 15.5219C4.88427 16.0005 12.0001 16.0005 12.0001 16.0005C12.0001 16.0005 19.1159 16.0005 20.8906 15.5219C21.8696 15.2585 22.6407 14.5148 22.9024 13.5294C23.3779 11.7432 23.3779 8.01665 23.3779 8.01665C23.3779 8.01665 23.3779 4.29007 22.9024 2.50395ZM9.67282 11.4001V4.6332L15.6203 8.01674L9.67282 11.4001Z","fill":"#E6EAF4"}));
}

Youtube.defaultProps = {"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
